import * as React from 'react'
import './style/jobs.scss'
import classnames from 'classnames'
import { Radio, Tabs } from 'antd'
import JobsList from '@halo/components/jobs-list/jobs-list'
import JobSchedulesList from '@halo/components/job-schedules-list/job-schedules-list'
import TabbedView from '@halo/components/tabbed-view/tabbed-view'
import { observer } from 'mobx-react'
import { useService } from '@halo/hooks/use-service'
import { AppState } from '@halo/stores/app.state'
import { AppService } from '@halo/services/app.service'

const Jobs = observer(() => {
    const appState = useService<AppState>(AppState)
    const appService = useService<AppService>(AppService)

    return (
        <div className={classnames('page', 'dev-jobs')}>
            <div className={classnames('page-wrapper')}>
                <TabbedView
                    size="small"
                    animated={false}
                    destroyInactiveTabPane={true} // kills auto-refresh
                    hideAdd={true}
                    availablePathKeys={['schedules']} // 'jobs' is the root path
                    defaultActiveKey={'jobs'}
                    tabBarExtraContent={
                        <div className="jobs-dtz-toggle">
                            <span>Time Zone Display: </span>
                            <Radio.Group
                                className="iter-utc-toggle"
                                size="small"
                                buttonStyle="solid"
                                value={appState.displayTimeZone !== 'UTC' ? 'local' : 'utc'}
                                onChange={(ev) => {
                                    const useLocal = ev.target.value === 'local'
                                    appService.setModuleLoading()
                                    setTimeout(() => {
                                        appState.displayTimeZone = useLocal ? 'America/Chicago' : 'UTC'
                                        appService.unsetModuleLoading()
                                    }, 500)
                                }}
                            >
                                <Radio.Button value="utc">UTC</Radio.Button>
                                <Radio.Button value="local">Local</Radio.Button>
                            </Radio.Group>
                        </div>
                    }
                >
                    <Tabs.TabPane key="jobs" tab="Jobs">
                        <JobsList />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="schedules" tab="Schedules">
                        <JobSchedulesList />
                    </Tabs.TabPane>
                </TabbedView>
            </div>
        </div>
    )
})

export default Jobs
